@if (participantInfo?.analystsComments) {
    <div class="participant-info-desc">
        {{ participantInfo?.analystsComments }}
    </div>
}
<div class="participant-info-desc">
    <div class="info-desc-item">
        <span>{{ sitecore.horseRacing.raceDetails.DaysOff }} </span> <span class="desc-item-value">{{ participantInfo?.daysOff || '-' }}</span>
    </div>
    @if (recentPositions) {
        <div class="info-desc-item">
            <span>{{ sitecore.horseRacing.raceDetails.RecentResults }} </span> <span class="desc-item-value">{{ recentPositions || '-' }}</span>
        </div>
    }
</div>
